import { render, staticRenderFns } from "./PxCamposCompraItemTableNeo.vue?vue&type=template&id=33fc2503&"
import script from "./PxCamposCompraItemTableNeo.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableNeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports